import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select, FormControlLabel, Checkbox} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import GetRole from "./user";
import { v4 as uuidv4 } from "uuid";
import { fetchHotelbyId, updateHoteldata, fetchDest, fetchConvertedTripsbyHotelid2} from "../api/customerapi";
import {formatDate2, removeDuplicates} from "./date.js"
import { useAppData } from "./appDataContext.js";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    textField2: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Hoteldataupdate = () => {

    const classes = useStyles();
    const { appData, loading } = useAppData();
    var { cuser, role } = GetRole();
    //console.log(cuser, role)
    const [ratedata, setratedata] = useState([]);
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [hotelData, sethotelData] =useState({
    hotel_name: "",
    hotel_area:"",
    hotel_destination: "",
    hotel_price_range:"",
    star_category: 0,
    hotel_tripadvisor_link: "",
    city_center_area: "",
    hotel_city:"",
    hotel_usp: "",
    room_category: "",
    hotel_reco:"",
    tag_onthebeach:false,
    tag_nearbeach:false,
    tag_bathtub:false,
    tag_mountainview:false,
    tag_riverfront:false,
    tag_oceanview:false,
    tag_cottage:false,
    tag_privatepool:false,
    });
    const [dest, setdest]=useState([])
    const [cities, setcities]=useState([])

    const getHotel = async (id) => {
      try{
        const data = await fetchHotelbyId(id);
        sethotelData({...data.data,
            tag_privatepool:data.data.tag_privatepool?data.data.tag_privatepool:false, 
            tag_onthebeach:data.data.tag_onthebeach?data.data.tag_onthebeach:false,
            tag_nearbeach:data.data.tag_nearbeach?data.data.tag_nearbeach:false,
            tag_bathtub:data.data.tag_bathtub?data.data.tag_bathtub:false,
            tag_mountainview:data.data.tag_mountainview?data.data.tag_mountainview:false,
            tag_riverfront:data.data.tag_riverfront?data.data.tag_riverfront:false, 
            tag_oceanview:data.data.tag_oceanview?data.data.tag_oceanview:false, 
            tag_cottage:data.data.tag_cottage?data.data.tag_cottage:false,
            room_category:data.data.room_category?data.data.room_category.toString().replaceAll(",","||"):""
        })
        setratedata(data.data.rate)
      }catch(err){
        console.log(err)
      }
    }

    const addcp = () => {
        //console.log(count)
    
        setratedata(
          ratedata.length == 0 ? [{ id: uuidv4() }] : [...ratedata, { id: uuidv4() }]
        );
      };
    
      const removecp = () => {
        setratedata([...ratedata].slice(0, ratedata.length - 1));
      };
    


    const getCities = async () => {
      try{
        const data = await fetchDest();
        //console.log(data.data);
        const citylist= data.data.map(arr => arr.dest[0] == hotelData.hotel_destination ? [arr.cities] : [])
        const citylist2=citylist?.filter(arr => arr.length !==0 )
        const citylist3=citylist2[0]
        // console.log(citylist3);
      
        setcities(citylist3 ? [...citylist3[0]] :[])
        // console.log(cities);
      }catch(err){
        console.log(err)
      }
    }

    // useEffect(()=>{
      
    // },[])

    useEffect(() => {
        getHotel(currentid)
        getDest()
    }, [currentid])

    useEffect(() => {
        
        getCities()
        
    }, [hotelData])

    const getDest = async () => {
      try{
      const data = await fetchDest();
      const temp=data.data.filter(d=>"order" in d)
      setdest(temp[0].dest);
    }catch(err){
      console.log(err)
    }
    }

    const startdatechange = (e, tid, id) => {
        const newdata = ratedata[tid];
        //console.log(newdata)
        const newitem = { ...newdata, start_date: e.target.value };
        //console.log(newitem)
        setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };

      const enddatechange = (e, tid, id) => {
        const newdata = ratedata[tid];
        //console.log(tid, id)
        const newitem = { ...newdata, end_date: e.target.value };
        //console.log(newitem)
        setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
      const basechange = (e, tid, id) => {
        const newdata = ratedata[tid];
        //console.log(newdata)
        const newitem = { ...newdata, base_price: e.target.value };
        //console.log(newitem)
        setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
      const baseextrachange = (e, tid, id) => {
        const newdata = ratedata[tid];
        //console.log(newdata)
        const newitem = { ...newdata, base_extrabed_price: e.target.value };
        //console.log(newitem)
        setratedata(ratedata.map((item) => (item.id == id ? newitem : item)));
        //setdata([...data, data[tid]=newitem])
        // console.log(cpdata)
      };
    //console.log(hotelData);

    const handleSubmit =async (e) => {
      try{
        e.preventDefault();
        // sethotelData({...hotelData,
        //     tag_privatepool:hotelData.tag_privatepool
        // })
        const rc=hotelData.room_category.split("||")
        const finalhotelData= {...hotelData,  updatedAt:new Date(), rate:ratedata, room_category:rc};
        const updatehotelResponse= await updateHoteldata(hotelData._id, finalhotelData);
        
        if(updatehotelResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for hotel with hotel id "+updatehotelResponse.data.hotel_id);
            window.location = ("/hoteldataentry/"+updatehotelResponse.data.hotel_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
        //console.log(hotelData)
      }catch(err){
        console.log(err)
      } 
    }

    const updatehotelreview=async()=>{
      try{
        const data=await fetchConvertedTripsbyHotelid2(hotelData.hotel_id)
        console.log(data.data)
        var temp=removeDuplicates(data.data, "trip_id")
        var temp2=temp.filter(t=>"post_trip_score" in t)
        var temp3=temp.filter(t=>"review_hotel_issue" in t && t.review_hotel_issue)
        var temp4=temp.filter(t=>"review_hotel_issue" in t && t.review_hotel_issue && t.review_hotel_name==hotelData.hotel_name)
        var tempobj={
          total_count:temp.length,
          review_present:temp2.length,
          hotel_issue:temp3.length,
          hotel_issue_with_name:temp4.length,
        }
        var text="Total Count: "+temp.length+ " || Review Present: "+temp2.length+" || Hotel Issue: "+temp3.length+" || Hotel Issue with name: "+temp4.length
        console.log(tempobj)
        alert(text)
      }catch(err){
        console.log(err)
      }
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Update Hotel (Hotel ID:{hotelData.hotel_id})</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_name} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_name: e.target.value})}/>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="primary destination">Destination</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="primary destination" required value={hotelData.hotel_destination} onChange={(e)=> sethotelData({...hotelData, hotel_destination: e.target.value})}>
                {dest.map(dest => {
                    return <MenuItem value={dest}>{dest}</MenuItem>})}
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="city">City *</InputLabel>
                <Select  classname={classes.textField} required labelId="city" value={hotelData.hotel_city} onChange={(e)=> sethotelData({...hotelData, hotel_city: e.target.value})}>
                    {cities?.map(city => {
                    return <MenuItem value={city}>{city}</MenuItem>})}
                    
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Hotel Area"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_area} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_area: e.target.value})}/>
                <TextField variant="standard"  label="City Center Area"  InputLabelProps={{ shrink: true }} value={hotelData.city_center_area} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, city_center_area: e.target.value})}/>
                <TextField variant="standard" label="Distance from center (number)"  InputLabelProps={{ shrink: true }} value={hotelData.distance_from_center} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, distance_from_center: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Star category">Star Category *</InputLabel>
                <Select   className={classes.textField} labelId="Star category" required InputLabelProps={{ shrink: true }} value={hotelData.star_category} onChange={(e)=> sethotelData({...hotelData, star_category: e.target.value})}>
                    <MenuItem value={0}>0</MenuItem>
                    <MenuItem value={1}>1</MenuItem>
                    <MenuItem value={2}>2</MenuItem>
                    <MenuItem value={3}>3</MenuItem>
                    <MenuItem value={4}>4</MenuItem>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={7}>7</MenuItem>
                </Select>
                </FormControl>
                <TextField variant="standard"  label="TripAdvisor Rating (number)"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_tripadvisor_rating} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_tripadvisor_rating: e.target.value})}/>
                <TextField variant="standard"  label="TripAdvisor Link"   InputLabelProps={{ shrink: true }} value={hotelData.hotel_tripadvisor_link} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, hotel_tripadvisor_link: e.target.value})}/>
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Price Range">Price Range *</InputLabel>
                <Select className={classes.textField} labelId="Price Range" required InputLabelProps={{ shrink: true }} value={hotelData.hotel_price_range} onChange={(e)=> sethotelData({...hotelData, hotel_price_range: e.target.value})}>
                    <MenuItem value={"Less than 1500"}>Less than 1500</MenuItem>
                    <MenuItem value={"1500-2500"}>1500-2500</MenuItem>
                    <MenuItem value={"2500-4000"}>2500-4000</MenuItem>
                    <MenuItem value={"4000-7000"}>4000-7000</MenuItem>
                    <MenuItem value={"7000-20000"}>7000-20000</MenuItem>
                    <MenuItem value={"More than 20000"}>More than 20000</MenuItem>
                </Select>
                </FormControl>        
                <TextField variant="standard"  label="Rezlive Id" InputLabelProps={{ shrink: true }} value={hotelData.rezlive_id} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, rezlive_id: e.target.value})}/>
                <TextField variant="standard"  label="Rezlive City Id" InputLabelProps={{ shrink: true }} value={hotelData.rezlive_city_id} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, rezlive_city_id: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="Priority">Priority</InputLabel>
                <Select className={classes.textField} disabled={cuser=="Vinit" || cuser=="Debayan"?0:1} labelId="Priority" InputLabelProps={{ shrink: true }} value={hotelData.hotel_reco} onChange={(e)=> sethotelData({...hotelData, hotel_reco: e.target.value})}>
                    <MenuItem value={""}>Clear</MenuItem>
                    <MenuItem value={"Highly Recommended"}>Highly Recommended</MenuItem>
                    <MenuItem value={"Recommended"}>Recommended</MenuItem>
                    <MenuItem value={"Not Recommended"}>Not Recommended</MenuItem>
                    <MenuItem value={"Not Allowed"}>Not Allowed</MenuItem>
                    
                </Select>
                </FormControl> 
                <TextField variant="outlined"  label="Priority Reason"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_reco_reason} className={classes.textField}  onChange={(e)=> sethotelData({...hotelData, hotel_reco_reason: e.target.value})}/>
                <TextField variant="standard"  label="Booking Id" InputLabelProps={{ shrink: true }} value={hotelData.booking_id} className={classes.textField} onChange={(e)=> sethotelData({...hotelData, booking_id: e.target.value})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Room Categories (Format : ABC||DEF)"  InputLabelProps={{ shrink: true }} value={hotelData.room_category} className={classes.textArea} fullWidth  onChange={(e)=> sethotelData({...hotelData, room_category: e.target.value})}/>
            </FormGroup>
                {/* <FormGroup row className={classes.formgroup}>

                </FormGroup> */}
                <FormGroup row className={classes.formgroup}>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_onthebeach} label="On the beach" onChange={(e)=> sethotelData({...hotelData, tag_onthebeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_nearbeach} label="Near beach" onChange={(e)=> sethotelData({...hotelData, tag_nearbeach: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_bathtub} label="Bathtub" onChange={(e)=> sethotelData({...hotelData, tag_bathtub: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_mountainview} label="Mountain View" onChange={(e)=> sethotelData({...hotelData, tag_mountainview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_riverfront} label="Riverfront" onChange={(e)=> sethotelData({...hotelData, tag_riverfront: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_oceanview} label="Ocean View" onChange={(e)=> sethotelData({...hotelData, tag_oceanview: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_cottage} label="Cottage" onChange={(e)=> sethotelData({...hotelData, tag_cottage: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_privatepool} label="Private Pool" onChange={(e)=> sethotelData({...hotelData, tag_privatepool: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_kitchen} label="Kitchen" onChange={(e)=> sethotelData({...hotelData, tag_kitchen: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_family_room} label="Family Room" onChange={(e)=> sethotelData({...hotelData, tag_family_room: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={hotelData.tag_family_room} label="Apartment" onChange={(e)=> sethotelData({...hotelData, tag_apartment: e.target.checked})}/>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Additional Benefits"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_benefit} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> sethotelData({...hotelData, hotel_benefit: e.target.value})}/>
                <TextField variant="outlined"  label="Internal Notes"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_internal_notes} className={classes.textArea} fullWidth multiline rows={3} onChange={(e)=> sethotelData({...hotelData, hotel_internal_notes: e.target.value})}/>
                <TextField
            variant="standard"
            type="date"
            label={"Benefit End Date"}
          
            InputLabelProps={{ shrink: true }}
            value={hotelData.hotel_benefit_end_date=== undefined?"":hotelData.hotel_benefit_end_date.split("T").slice(0, 1)}
            className={classes.textField2}
            onChange={(e)=> sethotelData({...hotelData, hotel_benefit_end_date: e.target.value})}
          />
            </FormGroup>
            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes/USP"  InputLabelProps={{ shrink: true }} value={hotelData.hotel_usp} className={classes.textArea} fullWidth multiline rows={8} onChange={(e)=> sethotelData({...hotelData, hotel_usp: e.target.value})}/>
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> Rates</Typography>
            {ratedata.map(item=>{
                return (<div>
                    <FormGroup row className={classes.formgroup}>
                    <TextField
            required
            variant="standard"
            type="date"
            label={"Start Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.start_date === undefined
                        ? ""
                        : item.start_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => startdatechange(e, e.target.id, item.id)}
          />
          <TextField
            required
            variant="standard"
            type="date"
            label={"End Date"}
            id={ratedata.indexOf(item)}
            InputLabelProps={{ shrink: true }}
            value={
                      item.end_date === undefined
                        ? ""
                        : item.end_date.split("T").slice(0, 1)
                    }
            className={classes.textField2}
            onChange={(e) => enddatechange(e, e.target.id, item.id)}
          />
          <TextField variant="outlined"  type="Number" label="Base"  value={
                      item.base_price === undefined
                        ? 0
                        : item.base_price
                    } 
                    id={ratedata.indexOf(item)}
                    className={classes.textField2} onChange={(e) => basechange(e, e.target.id, item.id)}/>
                <TextField variant="outlined"  type="Number" label="Base_extrabed" value={
                      item.base_extrabed_price === undefined
                        ? 0
                        : item.base_extrabed_price
                    }
                    id={ratedata.indexOf(item)}
                     className={classes.textField2}  onChange={(e) => baseextrachange(e, e.target.id, item.id)}/>
                    </FormGroup>
                </div>)
            })}
            <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addcp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removecp}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          {!(role=="Sales" || role=="SME")?(
            <FormGroup row className={classes.formgroup}>
               
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/listhoteldata" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={()=>updatehotelreview()} className={classes.button}>Review</Button>
            </FormGroup>
              
          ):("")}
           {"Hotel added by:"+hotelData.added_by}
            </form>
        </Paper>
     );
}

export default Hoteldataupdate;